const vocabulary = {
  en: {
    pageSubtitle: 'Word lists attached to each lesson — students study and practise them.',
    loadingWords: 'Loading vocabulary...',
    loadWordsFailed: 'Failed to load vocabulary',
    lessonLoadFailed: "Couldn't load this lesson's words. Retry before editing them.",
    accessDenied: 'You do not have access to this course vocabulary.',
    noLessonsTitle: 'No lessons yet',
    noLessonsDesc: 'Vocabulary is attached to lessons. Add lessons to this course first.',
    wordCountLabel: '{count} word',
    wordCountLabel_plural: '{count} words',
    wordsInLesson: '{count} word in this lesson',
    wordsInLesson_plural: '{count} words in this lesson',
    noWordsForLesson: 'No words yet. Add one, or paste a whole list with bulk import.',
    addWord: 'Add word',
    bulkImport: 'Bulk import',
    cancel: 'Cancel',
    add: 'Add',
    save: 'Save',
    edit: 'Edit',
    delete: 'Delete',
    moveUp: 'Move up',
    moveDown: 'Move down',
    termLabel: 'Russian word',
    termPlaceholder: 'слово',
    termStressedLabel: 'With stress',
    termStressedPlaceholder: 'сло́во',
    transliterationLabel: 'Transliteration',
    transliterationPlaceholder: 'slovo',
    partOfSpeechLabel: 'Part of speech',
    genderLabel: 'Gender',
    aspectLabel: 'Aspect',
    notSet: 'Not set',
    translationUzLabel: 'Uzbek',
    translationUzPlaceholder: "so'z",
    translationEnLabel: 'English',
    translationEnPlaceholder: 'word',
    exampleRuLabel: 'Example (RU)',
    exampleRuPlaceholder: 'Это новое слово.',
    exampleUzLabel: 'Example (UZ)',
    exampleUzPlaceholder: "Bu yangi so'z.",
    exampleEnLabel: 'Example (EN)',
    exampleEnPlaceholder: 'This is a new word.',
    audioUrlLabel: 'Audio URL',
    audioUrlPlaceholder: 'https://...',
    wordCreated: 'Word added',
    createWordFailed: 'Failed to add the word',
    wordUpdated: 'Word updated',
    updateWordFailed: 'Failed to update the word',
    wordDeleted: 'Word deleted',
    deleteWordFailed: 'Failed to delete the word',
    reorderFailed: 'Failed to reorder the words',
    moreActions: 'More actions',
    bulk: {
      title: 'Bulk import',
      parseAction: 'Preview',
      clear: 'Clear',
      back: 'Back to editing',
      previewCount: '{count} row ready to import',
      previewCount_plural: '{count} rows ready to import',
      noRowsParsed: 'Nothing to import yet — paste your list above.',
      colNum: '#',
      colRu: 'Russian',
      colUz: 'Uzbek',
      colEn: 'English',
      replaceWarning: 'Importing replaces the entire word list of this lesson.',
      importAction: 'Replace {count} word',
      importAction_plural: 'Replace {count} words',
      imported: 'Imported {count} word',
      imported_plural: 'Imported {count} words',
      importFailed: 'Bulk import failed',
    },
    partOfSpeech: {
      NOUN: 'Noun',
      VERB: 'Verb',
      ADJECTIVE: 'Adjective',
      ADVERB: 'Adverb',
      PRONOUN: 'Pronoun',
      NUMERAL: 'Numeral',
      PREPOSITION: 'Preposition',
      CONJUNCTION: 'Conjunction',
      PARTICLE: 'Particle',
      PHRASE: 'Phrase',
    },
    gender: {
      MASCULINE: 'Masculine',
      FEMININE: 'Feminine',
      NEUTER: 'Neuter',
      PLURAL: 'Plural',
    },
    aspect: {
      IMPERFECTIVE: 'Imperfective',
      PERFECTIVE: 'Perfective',
      BOTH: 'Both',
    },
    kpiTotalWords: 'Total words',
    kpiLessonsWithWords: 'Lessons with words',
    kpiLessonsTotal: 'Total lessons',
    kpiLessonsEmpty: 'Lessons without words',
    deleteTitle: 'Delete this word?',
    deleteDesc: 'The word is removed from the lesson.',
    previewTableAria: 'Rows to import',
  },
  ru: {
    pageSubtitle: 'Списки слов, привязанные к урокам, — студенты учат и отрабатывают их.',
    loadingWords: 'Загрузка словаря...',
    loadWordsFailed: 'Не удалось загрузить словарь',
    lessonLoadFailed: 'Не удалось загрузить слова этого урока. Повторите попытку перед редактированием.',
    accessDenied: 'У вас нет доступа к словарю этого курса.',
    noLessonsTitle: 'Уроков пока нет',
    noLessonsDesc: 'Словарь привязан к урокам. Сначала добавьте уроки в этот курс.',
    wordCountLabel: '{count} слово',
    wordCountLabel_few: '{count} слова',
    wordCountLabel_plural: '{count} слов',
    wordsInLesson: '{count} слово в этом уроке',
    wordsInLesson_few: '{count} слова в этом уроке',
    wordsInLesson_plural: '{count} слов в этом уроке',
    noWordsForLesson: 'Слов пока нет. Добавьте слово или вставьте весь список через массовый импорт.',
    addWord: 'Добавить слово',
    bulkImport: 'Массовый импорт',
    cancel: 'Отмена',
    add: 'Добавить',
    save: 'Сохранить',
    edit: 'Изменить',
    delete: 'Удалить',
    moveUp: 'Переместить выше',
    moveDown: 'Переместить ниже',
    termLabel: 'Русское слово',
    termPlaceholder: 'слово',
    termStressedLabel: 'С ударением',
    termStressedPlaceholder: 'сло́во',
    transliterationLabel: 'Транслитерация',
    transliterationPlaceholder: 'slovo',
    partOfSpeechLabel: 'Часть речи',
    genderLabel: 'Род',
    aspectLabel: 'Вид',
    notSet: 'Не указано',
    translationUzLabel: 'Узбекский',
    translationUzPlaceholder: "so'z",
    translationEnLabel: 'Английский',
    translationEnPlaceholder: 'word',
    exampleRuLabel: 'Пример (RU)',
    exampleRuPlaceholder: 'Это новое слово.',
    exampleUzLabel: 'Пример (UZ)',
    exampleUzPlaceholder: "Bu yangi so'z.",
    exampleEnLabel: 'Пример (EN)',
    exampleEnPlaceholder: 'This is a new word.',
    audioUrlLabel: 'Ссылка на аудио',
    audioUrlPlaceholder: 'https://...',
    wordCreated: 'Слово добавлено',
    createWordFailed: 'Не удалось добавить слово',
    wordUpdated: 'Слово обновлено',
    updateWordFailed: 'Не удалось обновить слово',
    wordDeleted: 'Слово удалено',
    deleteWordFailed: 'Не удалось удалить слово',
    reorderFailed: 'Не удалось изменить порядок слов',
    moreActions: 'Другие действия',
    bulk: {
      title: 'Массовый импорт',
      parseAction: 'Предпросмотр',
      clear: 'Очистить',
      back: 'Вернуться к вводу',
      previewCount: '{count} строка готова к импорту',
      previewCount_few: '{count} строки готовы к импорту',
      previewCount_plural: '{count} строк готовы к импорту',
      noRowsParsed: 'Импортировать пока нечего — вставьте список выше.',
      colNum: '№',
      colRu: 'Русский',
      colUz: 'Узбекский',
      colEn: 'Английский',
      replaceWarning: 'Импорт полностью заменит список слов этого урока.',
      importAction: 'Заменить на {count} слово',
      importAction_few: 'Заменить на {count} слова',
      importAction_plural: 'Заменить на {count} слов',
      imported: 'Импортировано {count} слово',
      imported_few: 'Импортировано {count} слова',
      imported_plural: 'Импортировано {count} слов',
      importFailed: 'Массовый импорт не удался',
    },
    partOfSpeech: {
      NOUN: 'Существительное',
      VERB: 'Глагол',
      ADJECTIVE: 'Прилагательное',
      ADVERB: 'Наречие',
      PRONOUN: 'Местоимение',
      NUMERAL: 'Числительное',
      PREPOSITION: 'Предлог',
      CONJUNCTION: 'Союз',
      PARTICLE: 'Частица',
      PHRASE: 'Фраза',
    },
    gender: {
      MASCULINE: 'Мужской',
      FEMININE: 'Женский',
      NEUTER: 'Средний',
      PLURAL: 'Множественное',
    },
    aspect: {
      IMPERFECTIVE: 'Несовершенный',
      PERFECTIVE: 'Совершенный',
      BOTH: 'Оба',
    },
    kpiTotalWords: 'Всего слов',
    kpiLessonsWithWords: 'Уроки со словами',
    kpiLessonsTotal: 'Всего уроков',
    kpiLessonsEmpty: 'Уроки без слов',
    deleteTitle: 'Удалить это слово?',
    deleteDesc: 'Слово будет удалено из урока.',
    previewTableAria: 'Строки для импорта',
  },
  uz: {
    pageSubtitle: "Har bir darsga biriktirilgan so'zlar ro'yxati — o'quvchilar shularni o'rganadi va mashq qiladi.",
    loadingWords: "Lug'at yuklanmoqda...",
    loadWordsFailed: "Lug'atni yuklab bo'lmadi",
    lessonLoadFailed: "Bu darsning so'zlari yuklanmadi. Tahrirlashdan oldin qayta urinib ko'ring.",
    accessDenied: "Bu kurs lug'atiga ruxsatingiz yo'q.",
    noLessonsTitle: "Hozircha darslar yo'q",
    noLessonsDesc: "Lug'at darslarga biriktiriladi. Avval bu kursga dars qo'shing.",
    wordCountLabel: "{count} ta so'z",
    wordCountLabel_plural: "{count} ta so'z",
    wordsInLesson: "Bu darsda {count} ta so'z",
    wordsInLesson_plural: "Bu darsda {count} ta so'z",
    noWordsForLesson: "Hozircha so'zlar yo'q. Bittasini qo'shing yoki ommaviy import orqali butun ro'yxatni joylashtiring.",
    addWord: "So'z qo'shish",
    bulkImport: 'Ommaviy import',
    cancel: 'Bekor qilish',
    add: "Qo'shish",
    save: 'Saqlash',
    edit: 'Tahrirlash',
    delete: "O'chirish",
    moveUp: "Yuqoriga ko'chirish",
    moveDown: "Pastga ko'chirish",
    termLabel: "Ruscha so'z",
    termPlaceholder: 'слово',
    termStressedLabel: "Urg'u bilan",
    termStressedPlaceholder: 'сло́во',
    transliterationLabel: 'Transliteratsiya',
    transliterationPlaceholder: 'slovo',
    partOfSpeechLabel: "So'z turkumi",
    genderLabel: 'Rod',
    aspectLabel: 'Vid',
    notSet: 'Belgilanmagan',
    translationUzLabel: "O'zbekcha",
    translationUzPlaceholder: "so'z",
    translationEnLabel: 'Inglizcha',
    translationEnPlaceholder: 'word',
    exampleRuLabel: 'Misol (RU)',
    exampleRuPlaceholder: 'Это новое слово.',
    exampleUzLabel: 'Misol (UZ)',
    exampleUzPlaceholder: "Bu yangi so'z.",
    exampleEnLabel: 'Misol (EN)',
    exampleEnPlaceholder: 'This is a new word.',
    audioUrlLabel: 'Audio havolasi',
    audioUrlPlaceholder: 'https://...',
    wordCreated: "So'z qo'shildi",
    createWordFailed: "So'zni qo'shib bo'lmadi",
    wordUpdated: "So'z yangilandi",
    updateWordFailed: "So'zni yangilab bo'lmadi",
    wordDeleted: "So'z o'chirildi",
    deleteWordFailed: "So'zni o'chirib bo'lmadi",
    reorderFailed: "So'zlar tartibini o'zgartirib bo'lmadi",
    moreActions: 'Boshqa amallar',
    bulk: {
      title: 'Ommaviy import',
      parseAction: "Ko'rib chiqish",
      clear: 'Tozalash',
      back: 'Tahrirga qaytish',
      previewCount: 'Importga {count} ta qator tayyor',
      previewCount_plural: 'Importga {count} ta qator tayyor',
      noRowsParsed: "Hozircha import qiladigan narsa yo'q — yuqoriga ro'yxatni joylashtiring.",
      colNum: '№',
      colRu: 'Ruscha',
      colUz: "O'zbekcha",
      colEn: 'Inglizcha',
      replaceWarning: "Import bu darsning butun so'zlar ro'yxatini almashtiradi.",
      importAction: "Almashtirish ({count} ta so'z)",
      importAction_plural: "Almashtirish ({count} ta so'z)",
      imported: "{count} ta so'z import qilindi",
      imported_plural: "{count} ta so'z import qilindi",
      importFailed: 'Ommaviy import amalga oshmadi',
    },
    partOfSpeech: {
      NOUN: 'Ot',
      VERB: "Fe'l",
      ADJECTIVE: 'Sifat',
      ADVERB: 'Ravish',
      PRONOUN: 'Olmosh',
      NUMERAL: 'Son',
      PREPOSITION: 'Predlog',
      CONJUNCTION: "Bog'lovchi",
      PARTICLE: 'Yuklama',
      PHRASE: 'Ibora',
    },
    gender: {
      MASCULINE: 'Erkak rodi',
      FEMININE: 'Ayol rodi',
      NEUTER: "O'rta rod",
      PLURAL: "Ko'plik",
    },
    aspect: {
      IMPERFECTIVE: 'Tugallanmagan',
      PERFECTIVE: 'Tugallangan',
      BOTH: 'Ikkalasi',
    },
    kpiTotalWords: "Jami so'zlar",
    kpiLessonsWithWords: "So'zli darslar",
    kpiLessonsTotal: 'Jami darslar',
    kpiLessonsEmpty: "So'zsiz darslar",
    deleteTitle: "So'zni o'chirasizmi?",
    deleteDesc: "So'z darsdan olib tashlanadi.",
    previewTableAria: 'Import uchun qatorlar',
  },
};

export default vocabulary;
